module.exports = __webpack_public_path__ + "static/media/empacadoras-1.665dda39.jpg";